<template>
  <div class="pages">
    <app-header />
    <!-- 店铺信息 -->
    <div class="store-item">
      <div class="top">
        <div class="flex">
          <img src="../../assets/good-fresh/good-fresh-bg-outer.jpg" alt="" class="store-img" />
          <div>
            <div>TABI奢品拍卖店</div>
            <el-rate v-model="rateValue" disabled />
          </div>
        </div>
        <div>
          <el-button size="small" @click="serviceOpen">联系客服</el-button>
        </div>
      </div>
      <!-- 分类 -->
      <div class="tab_box">
        <span class="" v-for="(item, index) in tabList" :key="index" :class="tabIndex == index?'tabPitch':''"
          @click="tabIndex = index">
          {{ item.name }}</span>
      </div>
    </div>
    <!-- 店铺信息 end -->

    <!-- 首页 -->
    <div class="slideshow" v-if="tabIndex == 0">
      <!-- 轮播图 -->
      <el-carousel height="480px">
        <el-carousel-item v-for="(item,index) in slideContent" :key="index">
          <img :src="require('../../assets/main-view/'+item.name)" alt="" class="carousel_img">
        </el-carousel-item>
      </el-carousel>
      <!-- 商品列表 -->
      <goods-list />
    </div>

    <!-- 店铺商品 -->
    <div class="goods_box" v-else>
      <div class="left">
        <div class="search">
          <div class="title">本店搜索</div>
          <div class="items">
            <p>关键字</p>
            <el-input v-model="keyword" placeholder="请输入内容" class="input"></el-input>
          </div>
          <div class="items">
            <p>价格</p>
            <el-input v-model="minPrice" class="input2"></el-input>
            -
            <el-input v-model="maxprice" class="input2"></el-input>
          </div>
        </div>
        <div class="class_box">
          <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>

        </div>
      </div>
      <div class="right">
        <div class="flex align-center line_item">
          <div>
            <span>所有分类</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <el-dropdown>
            <span class="dropdown_text">
              分类选择 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>螺蛳粉</el-dropdown-item>
              <el-dropdown-item disabled>双皮奶</el-dropdown-item>
              <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-input v-model="input" placeholder="在当前结果中搜索" class="goods_search">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <!-- 排序/分页 -->
        <div class="flex justify-between line_item">
          <div class="">
            <span v-for="(item,key1) in sortList" :key="key1" :class="sortIndex == key1?'sortPitch':''">
              {{ item.name }}
            </span>
          </div>
          <div class="flex align-center">
            <span class="text-16">1/17</span>
            <img src="../../assets/icon/left.png" alt="" class="icon-img">
            <img src="../../assets/icon/right.png" alt="" class="icon-img">
          </div>
        </div>
        <!-- 商品列表 -->
        <div id="good-list">
          <el-row :gutter="20">
            <el-col :span="4.3" v-for="(item,index) in goodFreshList" :key="index">
              <div class="goods-item" @click="gotoDetail(item)">
                <img src="@/assets/good-fresh/good1.png" alt="" class="goods-img">
                <div class="content-box">
                  <div>{{ item.title }}</div>
                  <div class="flex justify-between">
                    <span>
                      <span class="price">
                        <span style="font-size: 12px;">￥</span>
                        <span>12.6</span>
                      </span>
                      <span class="crossedPrice">￥11.1</span>
                    </span>
                    <span class="salesVolume">销量2334</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 悬浮框 -->
    <rightSuspension />
    <!-- 客服 -->
    <kefu ref="kefu" />
  </div>
</template>
<script>
  import AppHeader from "@/components/AppHeader";
  import goodsList from "./components/goodsList.vue";
  import rightSuspension from "@/components/rightSuspension.vue";
  import kefu from "@/components/kefu.vue"
  export default {
    name: "shopIndex",
    components: {
      "app-header": AppHeader,
      "goods-list": goodsList,
      rightSuspension,
      kefu
    },
    computed: {},
    data() {
      return {
        tabList: [
          {
            id: 1,
            name: "首页",
          },
          {
            id: 2,
            name: "全部商品",
          },
          {
            id: 3,
            name: "空调",
          },
          {
            id: 4,
            name: "冰箱",
          },
          {
            id: 5,
            name: "洗衣机",
          },
          {
            id: 6,
            name: "热水器",
          },
          {
            id: 7,
            name: "厨房大电",
          },
        ],
        tabIndex: 1,
        treeData: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        keyword: '',//关键字
        maxprice: '',
        minPrice: '',
        goodFreshList: [
          {
            index: 0,
            title: '绿鲜知 都市轻食 沙拉菜组合',
            price: '24.80',
            quantity: '700g'
          },
          {
            index: 1,
            title: '进口 巨无霸牛油果 单果重160-220g',
            price: '44.80',
            quantity: '4个',
          },
          {
            index: 2,
            title: '禧美海产 厄瓜多尔白虾（特大号）',
            price: '109.00',
            quantity: '1kg/盒',
          },
          {
            index: 3,
            title: '鲜活 加拿大进口 鲜活珍宝蟹',
            price: '399.00',
            quantity: '600-800g',
          },
          {
            index: 4,
            title: '德青源A+鲜鸡蛋',
            price: '129.00',
            quantity: '64枚',
          },
          {
            index: 5,
            title: '春禾秋牧 板腱牛排 ',
            price: '37.80',
            quantity: '200g',
          },
          {
            index: 6,
            title: '瑞士原装进口 大孔原制奶酪块芝士片',
            price: '89.00',
            quantity: '200g',
          },
          {
            index: 7,
            title: '法国原装进口伊斯尼杯装淡奶油',
            price: '290.00',
            quantity: '1L',
          },
        ],
        // 轮播图
        slideContent: [
          {
            index: 0,
            name: '1.jpg'
          },
          {
            index: 1,
            name: '2.jpg'
          },
          {
            index: 2,
            name: '3.jpg'
          },
          {
            index: 3,
            name: '4.jpg'
          },
        ],
        sortList: [
          {
            id: 1,
            name: '综合排序',
          },
          {
            id: 1,
            name: '销量',
          },
          {
            id: 1,
            name: '价格',
          }
        ],
        sortIndex: ''
      };
    },
    methods: {
      // 客服弹窗
      serviceOpen() {
        this.$refs.kefu.show()
      },
      handleNodeClick(data) {
        console.log(data);
      }
    },
  };
</script>
<style scoped>
  .pages {
    background: #f8f8f8;
  }

  /* 店铺 */
  .store-item {
    width: 1280px;
    margin: 16px auto;
    padding: 0 24px;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 16px;
  }

  .store-item .top {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
  }

  .store-item .store-img {
    width: 48px;
    height: 48px;
    margin-right: 12px;
    border-radius: 8px;
  }

  .store-item .tab_box {
    display: flex;
    padding: 20px 0;
  }

  .store-item .tab_box span {
    flex: 1;
    color: #333;
    text-align: center;
    font-size: 16px;
  }

  .store-item .tab_box .tabPitch {
    color: #FD3B00;
    font-weight: bold;
  }

  /* 轮播图 */
  .slideshow {
    width: 1280px;
    margin: 16px auto;
  }

  .carousel_img {
    width: 1280px;
    height: 480px;
  }

  /* 店内商品列表 */
  .goods_box {
    width: 1280px;
    display: flex;
    margin: 16px auto;
  }

  .goods_box .left {
    width: 200px;
    margin-right: 16px;
  }

  .goods_box .left .search {
    width: 200px;
    height: 211px;
    background: #FFFFFF;
    border-radius: 16px;
    margin-bottom: 16px;
  }

  .goods_box .left .title {
    width: 200px;
    height: 45px;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    padding: 0 12px;
    line-height: 45px;
    box-sizing: border-box;
    background: rgba(254, 128, 0, 0.2);
    border-radius: 16px 16px 0px 0px;
  }

  .goods_box .left .items {
    padding: 6px;
  }

  .goods_box .left .input {
    width: 176px;
    height: 36px;
    margin-top: 8px;
    background: #F8F8F8;
    border-radius: 18px;
  }

  .goods_box .left .input2 {
    width: 80px;
    height: 32px;
    margin-top: 8px;
    background: #F8F8F8;
    border-radius: 18px;
  }

  .goods_box .left .class_box {
    width: 200px;
    height: 867px;
    padding: 20px 12px;
    background: #FFFFFF;
    border-radius: 16px;
    box-sizing: border-box;
  }

  .goods_box .right {
    width: 1064px;
    height: 1094px;
    background: #FFFFFF;
    border-radius: 16px 16px 16px 16px;
  }

  .icon-img {
    width: 16px;
    height: 16px;
  }

  .goods_box .right .line_item {
    font-size: 14px;
    padding: 12px;
    margin: 0 16px;
    border-bottom: 1px solid #eee;
  }

  .dropdown_text {
    font-size: 14px;
  }

  .goods_search {
    width: 240px;
    height: 32px;
    margin-left: 20px;
    background: #F8F8F8;
    border-radius: 16px;
  }

  .goods_box .right .line_item .sortPitch {
    color: #FD3B00;
  }

  #good-list {
    width: 1064px;
    margin: auto;
    padding: 12px;
    padding-right: 0;
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    box-sizing: border-box;
  }

  .goods-item {
    width: 194px;
    height: 291px;
    margin-bottom: 40px;
    background: #fff;
  }

  .goods-img {
    width: 194px;
    height: 194px;
    border-radius: 8px 8px 0 0;
  }

  .content-box {
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .price {
    color: #FD3B00;
    font-size: 18px;
  }
</style>


// WEBPACK FOOTER //
// src/view/shop/shopIndex.vue